<script>
	export default {
		name: 'ObjectExecuter',
		methods: {
			arrayObject(object) {
				// object = { a: { filterKey: 10 }, b: { filterKey: 20 }, c: { filterKey: 30 }, ... }
				// -> array = [ { key: 'a', filterKey: 10 }, { key:'b', filterKey: 20 }, { key: 'c', filterKey: 30 }, ... ]
				const self_ = this;

				if(self_.isEmpty(object)) { return [] }

				let result_ = {}

				return Object.keys(object).map(key => {
					result_ = object[key]
					result_.key = key;
					return result_
				})
			},
			findObject(object, filterKey, filterValue) {
				// object = { a: { filterKey: 10 }, b: { filterKey: 20 }, c: { filterKey: 30 }, ... }
				// -> array = [ { key: 'a', filterKey: 10 }, { key:'b', filterKey: 20 }, { key: 'c', filterKey: 30 }, ... ]
				// -> { key: 'a', filterKey: 10 }
				const self_ = this;

				if(self_.isEmpty(object)) { return [] }

				const array_ = self_.arrayObject(object)

				return self_.findArray(array_, filterKey, filterValue)
			},
			filterObject(object, filterKey, filterValue) {
				// object = { a: { filterKey: 10 }, b: { filterKey: 20 }, c: { filterKey: 30 }, ... }
				// -> array = [ { key: 'a', filterKey: 10 }, { key:'b', filterKey: 20 }, { key: 'c', filterKey: 30 }, ... ]
				// -> { a: { filterKey: 10 }, b: { filterKey: 20 } }
				const self_ = this;

				if(self_.isEmpty(object)) { return {} }

				const array_ = self_.arrayObject(object)

				const subset_ = self_.filterArray(array_, filterKey, filterValue)

				return self_.objectArray(subset_)
			},
			parseObject(object) {
				const self_ = this;
				if(!self_.isObject(object)) { return object }
				return JSON.parse(JSON.stringify(object))
			},
			sortObject(targetObject, sortKey, orderType) {
				// targetObject = {
				//		key: {
				//			sortKey: x,
				//			...
				//		}, ...
				// }
				const self_ = this;

				if(self_.isEmpty(targetObject)) { return {} }

				if(self_.isFalse(sortKey)) { sortKey = 'key' }
				if(self_.isFalse(orderType)) { orderType = 'asc' }
				
				let obj_ = {}
				let array_ = []

				let sortedArray_ = []
				let sortedObj_ = {}

				Object.keys(targetObject).forEach(key => {
					const org_ = key;

					if(self_.isNumber(Number(key))) {
						key = ('00000000000000000000' + Number(key)).slice(-20)
					}

					if(sortKey == 'key') {
						obj_ = {
							key: key, 
							org: org_,
							order: org_
						}
					} else {
						if(targetObject[org_][sortKey]) {
							obj_ = {
								key: key, 
								org: org_,
								order: targetObject[org_][sortKey]
							}
						}
					}
					if(self_.isObject(obj_)) { array_.push(obj_) }
				})

				if(self_.isEmpty(array_)) { return null } // nothing to be sorted

				sortedArray_ = self_.sortArray(array_, 'order', orderType)
				sortedArray_.forEach(item => {
					sortedObj_[item.key] = targetObject[item.org]
				})

				return sortedObj_
			},
			getObjectFirstKey(object, order) {
				const self_ = this;

				if(self_.isFalse(order)) { order = 'order' }

				const sorted_ = self_.sortObject(object, order)
				const keys_ = Object.keys(sorted_)

				return keys_[0]
			},
			getObjectLastKey(object, order) {
				const self_ = this;

				if(self_.isFalse(order)) { order = 'order' }

				const sorted_ = self_.sortObject(object, order)
				const keys_ = Object.keys(sorted_)
				
				return keys_[keys_.length - 1]
			},
			getObjectNextKey(object, currentKey, order) {
				const self_ = this;

				if(self_.isFalse(order)) { order = 'order' }

				const sorted_ = self_.sortObject(object, order)

				let result_ = null;
				let next_ = false;

				Object.keys(sorted_).forEach(key => {
					if(self_.isFalse(result_)) {
						if(next_) { result_ = key }
						else {
							if(key == currentKey) {
								next_ = true;
							}
						}
					}
				})
				return result_
			},
			getObjectPreviousKey(object, currentKey, order) {
				const self_ = this;

				if(self_.isFalse(order)) { order = 'order' }

				const sorted_ = self_.sortObject(object, order)

				let result_ = null;
				let previous_ = false;

				Object.keys(sorted_).forEach(key => {
					if(self_.isFalse(result_)) {
						if(key == currentKey) {
							result_ = previous_;
						} else {
							previous_ = key;
						}
					}
				})
				return result_
			}
		}
	}
</script>